import axios from "axios";
import { API_URL } from "@/helpers";

export const checklistService = {
  getChecklists,
  restore,
  addChecklist,
  editChecklist,
  deleteChecklist
};

export function getChecklists() {
  return axios.get(`${API_URL}/2/checklist/`);
}

export function restore(checklist) {
  return axios.post(
    `${API_URL}/1/checklist/restore/`,
    (({ language }) => ({
      language
    }))(checklist)
  );
}

export function addChecklist(checklist) {
  return axios.post(
    `${API_URL}/1/checklist/add/`,
    (({ name, language, sections }) => ({
      name,
      language,
      sections
    }))(checklist)
  );
}

export function editChecklist(checklist) {
  return axios.post(
    `${API_URL}/1/checklist/edit/`,
    (({ position, name, language, sections }) => ({
      position,
      name,
      language,
      sections
    }))(checklist)
  );
}

export function deleteChecklist(position) {
  return axios.delete(`${API_URL}/1/checklist/delete/${position}`);
}
